import marketingSeo from '../seo/marketing-seo.json';
import { PRICING_PLANS, getPlanPriceRange } from './pricingPlans';

export const SITE_URL = marketingSeo.siteUrl;
export const SITE_NAME = marketingSeo.siteName;
export const META_DESCRIPTION = marketingSeo.metaDescription;
export const FAQ_ITEMS = marketingSeo.faq;

const { lowPrice, highPrice } = getPlanPriceRange();

export const buildStructuredData = () => ({
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': `${SITE_URL}/#organization`,
      name: SITE_NAME,
      url: SITE_URL,
      description: 'Task management software for cleaning companies and field service teams.',
      logo: `${SITE_URL}/service_in_mind_logo_dark.png`
    },
    {
      '@type': 'SoftwareApplication',
      '@id': `${SITE_URL}/#software`,
      name: SITE_NAME,
      url: SITE_URL,
      applicationCategory: 'BusinessApplication',
      operatingSystem: 'Web',
      description:
        'Task management platform for service businesses with assignments, checklists, photos, and team coordination.',
      offers: {
        '@type': 'AggregateOffer',
        lowPrice,
        highPrice,
        priceCurrency: 'USD',
        offerCount: String(PRICING_PLANS.length),
        description: 'Contact us to get started with the plan that fits your team'
      }
    },
    {
      '@type': 'FAQPage',
      '@id': `${SITE_URL}/#faq`,
      mainEntity: FAQ_ITEMS.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.answer
        }
      }))
    }
  ]
});

export const buildNoscriptLandingHtml = () => {
  const featureSections = marketingSeo.features
    .map(
      (feature) =>
        `<section><h2>${feature.title}</h2><p>${feature.body}</p></section>`
    )
    .join('\n');

  const faqSections = FAQ_ITEMS.map(
    (item) =>
      `<article><h3>${item.question}</h3><p>${item.answer}</p></article>`
  ).join('\n');

  return `<main id="static-landing-fallback">
  <header>
    <h1>${marketingSeo.hero.headline}</h1>
    <p>${marketingSeo.hero.description}</p>
    <nav aria-label="Primary">
      <ul>
        <li><a href="${SITE_URL}/register">Create account</a></li>
        <li><a href="${SITE_URL}/login">Log in</a></li>
        <li><a href="${SITE_URL}/#contact">Contact</a></li>
        <li><a href="${SITE_URL}/llms.txt">LLMs overview</a></li>
      </ul>
    </nav>
  </header>
  <section aria-labelledby="static-features-heading">
    <h2 id="static-features-heading">Why Service in Mind</h2>
    ${featureSections}
  </section>
  <section aria-labelledby="static-faq-heading">
    <h2 id="static-faq-heading">Frequently asked questions</h2>
    ${faqSections}
  </section>
  <footer>
    <nav aria-label="Legal">
      <ul>
        <li><a href="${SITE_URL}/privacy">Privacy Policy</a></li>
        <li><a href="${SITE_URL}/terms">Terms of Service</a></li>
        <li><a href="${SITE_URL}/cookies">Cookie Policy</a></li>
      </ul>
    </nav>
  </footer>
</main>`;
};

export const buildHeadMetaHtml = () => {
  const title = marketingSeo.title;
  return `<link rel="canonical" href="${SITE_URL}/" />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="${SITE_URL}/" />
    <meta property="og:site_name" content="${SITE_NAME}" />
    <meta property="og:title" content="${title}" />
    <meta property="og:description" content="${META_DESCRIPTION}" />
    <meta property="og:image" content="${marketingSeo.ogImage}" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="${title}" />
    <meta name="twitter:description" content="${META_DESCRIPTION}" />
    <meta name="twitter:image" content="${marketingSeo.ogImage}" />`;
};
